exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-screen h1 {\n  margin: 0;\n  margin-bottom: 24px;\n  margin-top: calc(-24px - 1.5em);\n}\n.login-screen .v-content {\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n}\n.login-screen .v-content__wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n", ""]);

// exports
